export default __webpack_public_path__ + "static/media/peacemaker.5fd0a189.png";